import React from 'react';
import type { ChatConfigResponse as ChatConfig } from '../../hooks/useChatConfig';

interface Props {
  config: ChatConfig;
}

export function WelcomeScreen({ config }: Props) {
  return (
    <div className="flex flex-col items-center justify-center h-full gap-4 text-center px-6">
      <span className="text-5xl">{config.avatar_emoji}</span>
      <h2 className="text-xl font-semibold text-gray-800">{config.agent_name}</h2>
      <p className="text-sm text-gray-500 max-w-sm whitespace-pre-line">
        {config.welcome_message}
      </p>
    </div>
  );
}
